import {bankLists} from "../config/banksList";

const adapterBankList = () => {
  return bankLists.map(item => ({label: `${item.bank_code} - ${item.bank_name}`, value: item.bank_code}));
};

const normalizeBankCode = code => {
  if (code == null || code === "") return null;
  const parsed = Number(code);
  return Number.isNaN(parsed) ? null : String(parsed);
};

const findBankData = account => {
  const target = normalizeBankCode(account?.bank_code);
  if (!target) return undefined;
  return bankLists.find(bank => normalizeBankCode(bank.bank_code) === target);
};

// [Disabled-edit-delete-pagoMovil]
// const findBankData = account => {
//   return bankLists.find(bank => Number(bank.bank_code) === account.bank_code);
// };

const adapterBankWithAccount = account => {
  return account.map(item => ({label: findBankData(item)?.bank_name, value: item.ID}));
};

const getDataFromAccount = (account, id) => {
  return account.find(item => item.ID === id);
};

export {adapterBankList, adapterBankWithAccount, findBankData, getDataFromAccount};
